import { InvitationMessage, InvitationMessageType, websocket } from '@playcastdotio/Messaging';
import { sendMessage } from '..';
import { getPersistentPlayerId } from '../../';
import { onAlias, onAliasUpdate, onInviteQueryResponse } from '../../api';
import { lobbyState, invitationState2 } from '../../stores';

export const handleInvitationMessage = (message: InvitationMessage) => {
  console.log('Invitation message:', message);
  switch (message.type) {
    case InvitationMessageType.INVITATION_QUERY_RESPONSE: {
      console.warn('Invitation query response');
      onInviteQueryResponse(message.invitationId, message.invitation);
      break;
    }
    case InvitationMessageType.INVITATION_IS_ALIAS: {
      console.warn('Invitation is alias');
      invitationState2.updateState({
        ...invitationState2.currentState,
        isAlias: true,
      });
      onAlias(message.invitations, message.aliasInfo.name, message.aliasInfo.greeting);
      break;
    }
    case InvitationMessageType.INVITATION_ALIAS_CHANGED: {
      console.warn('Invitation alias changed');
      onAliasUpdate(message.updatedInvitation);
      break;
    }
    case InvitationMessageType.INVITATION_JOIN_SUCCESS: {
      console.warn('Invitation join success');
      const position = message.position;
      invitationState2.updateState({
        ...invitationState2.currentState,
        invitationPlayerId: message.invitationPlayerId,
      });

      lobbyState.updateState({
        ...lobbyState.currentState,
        position,
      });
      break;
    }
    case InvitationMessageType.INVITATION_JOIN_ERROR: {
      console.warn('Invitation join err');
      break;
    }
    case InvitationMessageType.INVITATION_QUERY:
    case InvitationMessageType.INVITATION_JOIN:
    case InvitationMessageType.INVITATION_STORE:
    case InvitationMessageType.INVITATION_STORE_ERROR:
    case InvitationMessageType.INVITATION_STORE_SUCCESS: {
      console.warn('Server received message it should not have received');
      console.log(message);
      break;
    }
  }
};

export const queryInvitation = (invitationId: string) => {
  sendMessage(websocket.generators.invitation(InvitationMessageType.INVITATION_QUERY, { invitationId }));
};

export const requestJoinInvitation = (invitationId: string, displayName: string) => {
  sendMessage(
    websocket.generators.invitation(InvitationMessageType.INVITATION_JOIN, {
      invitationId,
      displayName,
      persistentId: getPersistentPlayerId(),
    }),
  );
};
